<app-title-bar rootBreadCrumbs="['i18n.core.navigation.administration']"
  titleText="i18n.base.user-management.header"></app-title-bar>
<div class="row align-items-center">
  <div class="col-12">
    <div class="d-flex align-items-center mb-2">
      @if(canSelectClients){
        <app-client-autocomplete [selectedClient]="selectedClient" (selectedClientChange)="onClientSelected($event)" class="client-autocomplete flex-fill me-2"></app-client-autocomplete>
      }
      <app-search-field (searchTextChanged)="onSearchTextChanged($event)" class="me-auto"></app-search-field>
      <ejs-checkbox label="{{ 'i18n.shared.show-all' | translate }}" [(checked)]="showInactive"
        cssClass="checkbox-large ms-auto"></ejs-checkbox>
    </div>
  </div>
</div>
<div class="row">
  <div class="col">
    <ejs-grid #grid class="grid-with-toolbar" width='100%' rowHeight='38' [dataSource]="data" [allowFiltering]='true'
      [filterSettings]='filterSettings' [allowSorting]='true' [pageSettings]='pageSettings' [allowPaging]='true'
      [editSettings]="customEditSettings" [searchSettings]="searchOptions" (actionComplete)="actionComplete($event)"
      (actionBegin)="actionBegin($event)" (rowDataBound)="onRowDataBound($event)" (commandClick)="commandClick($event)">
      <ng-template #toolbarTemplate let-data>
        <ejs-toolbar>
          <e-items>
            @if(canAddServiceUser){
              <e-item [text]="'i18n.base.user-management.buttons.add-service-access' | translate" prefixIcon="e-icons icon-add" (click)="addUser(Role.InterfaceServiceAccess)"></e-item>
            }
            @if(canAddAssetStorageGroupMember){
              <e-item [text]="'i18n.base.user-management.buttons.add-asset-storage-group-member' | translate" prefixIcon='e-icons icon-add' (click)="addUser(Role.AssetStorageGroupMember)"></e-item>
            }
          </e-items>
        </ejs-toolbar>
      </ng-template>
      <e-columns>
        <e-column headerText='id' field='userId' [visible]='false' [isPrimaryKey]='true'></e-column>
        <e-column [headerText]="'i18n.base.user-management.column-headers.firstName' | translate" field="firstname"
          clipMode='EllipsisWithTooltip' type="string"></e-column>
        <e-column [headerText]="'i18n.base.user-management.column-headers.lastName' | translate" field="lastname"
          clipMode='EllipsisWithTooltip' type="string"></e-column>
        <e-column [headerText]="'i18n.base.user-management.column-headers.client' | translate" field="client.name"
          clipMode='EllipsisWithTooltip' [customAttributes]='noFilterColumnAttributes'>
          <ng-template #template let-data>
            <span>{{getClientName(data.client)}}</span>
          </ng-template>
        </e-column>
        <e-column [headerText]="'i18n.base.user-management.column-headers.email' | translate" field="email"
          clipMode='EllipsisWithTooltip'></e-column>
        <e-column [headerText]="'i18n.base.user-management.column-headers.userName' | translate" field="userName"
          clipMode='EllipsisWithTooltip'></e-column>
        <e-column [headerText]="'i18n.base.user-management.column-headers.language' | translate" field="language"
          [filter]="languageFilter" width='135px'></e-column>
        <e-column [headerText]="'i18n.base.user-management.column-headers.role' | translate" field="{{rolesFieldName}}"
          clipMode='EllipsisWithTooltip' [filter]="roleFilter" [allowSorting]='false'>
          <ng-template #filterItemTemplate let-data>{{formatFilterRole(data)}}</ng-template>
          <ng-template #template let-data>
            <span>{{formatRoles(data)}}</span>
          </ng-template>
        </e-column>
        <e-column [headerText]="'i18n.base.user-management.column-headers.enabled' | translate" field="enabled"
          [visible]='showInactive' [filter]="isActiveFilter" width='100px'>
          <ng-template #filterItemTemplate let-data>{{formatIsActive(data, 'enabled')}}</ng-template>
          <ng-template #template let-data>
            @if(data.enabled){
              <div class="e-icons icon-checkmark align-middle"></div>
            }
          </ng-template>
        </e-column>
        <e-column headerText="" [commands]='gridCommands' width='110px' textAlign="left"></e-column>
      </e-columns>
      <ng-template #editSettingsTemplate let-data>
        <app-user-edit-form [userEditForm]="gridEditForm" [selectedClient]="selectedClient">
        </app-user-edit-form>
      </ng-template>
    </ejs-grid>
  </div>
</div>
